import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["autopay", "pay", "summary"]

  hideTermsDependents() {
    this.autopayTarget.classList.add("hidden")
    this.payTarget.classList.add("hidden")
    this.summaryTarget.classList.add("hidden")
  }

  showTermsDependents() {
    this.autopayTarget.classList.remove("hidden")
    this.payTarget.classList.remove("hidden")
    this.summaryTarget.classList.remove("hidden")
  }

  toggleTermsDependents(e) {
    const checkbox = e.currentTarget

    if (checkbox.checked) {
      this.showTermsDependents()
    } else {
      this.hideTermsDependents()
    }
  }
}
